import React from 'react';

var MobileLobbySection = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-m-lobby-section' },
        React.createElement("div", { className: 'scroll-holder' },
            React.createElement("div", { className: 'scrollable-container' }, children)));
};

export { MobileLobbySection };
